module.exports = __webpack_public_path__ + "static/photo-396585ecc56bb47ee41d2021a5a1ab08.jpg";